import React, { lazy, Suspense } from 'react'
import { Switch, Route, NotFound } from '@fs/zion-router'
import ErrorBoundary from '@fs/zion-error-boundary'
import { useFeatureFlag } from '@fs/zion-flags'
import { geoData } from '@fs/zion-config'
import TreeOverviewPageSkeleton from './components/family-tree/TreeOverviewPage/TreeOverviewPageSkeleton'
import PhilippinesRedirect from './components/family-tree/TreeOverviewPage/PhilippinesRedirect'

const TreeOverviewPage = lazy(() => import('./components/family-tree/TreeOverviewPage/TreeOverviewPage'))

export default function App() {
  const isPhilippines = useFeatureFlag('homelands_treeOverview_philippines')?.isOn && geoData?.country === 'PH'

  return (
    <ErrorBoundary>
      <Suspense fallback={<TreeOverviewPageSkeleton />}>
        <Switch>
          <Route exact path="/" component={isPhilippines ? PhilippinesRedirect : TreeOverviewPage} />
          <Route component={NotFound} />
        </Switch>
      </Suspense>
    </ErrorBoundary>
  )
}
